// Nerissa: tallas, carrito real de Shopify (cart/add.js, cart.js) y detalles de interfaz
document.documentElement.classList.add('js');
const RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const cop = centavos => '$' + Math.round(centavos / 100).toLocaleString('es-CO');
const estado = { talla: null };

// tallas: todos los grupos de la página quedan sincronizados
function pintarTallas() {
  document.querySelectorAll('.talla').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.talla === estado.talla)));
  document.querySelectorAll('[data-aviso-talla]').forEach(el => { el.hidden = true; });
}
document.addEventListener('click', e => {
  const t = e.target.closest('.talla');
  if (t && !t.disabled) { estado.talla = t.dataset.talla; pintarTallas(); }
});
const varianteElegida = () => document.querySelector('.talla[data-variant][data-talla="' + CSS.escape(estado.talla || '') + '"]')?.dataset.variant;

// carrito
const carrito = document.querySelector('[data-carrito]');
const abrirCarrito = () => { carrito.classList.add('abierto'); carrito.querySelector('.carrito__panel').focus(); };
const cerrarCarrito = () => carrito.classList.remove('abierto');
async function pintarCarrito() {
  const c = await (await fetch(RAIZ + 'cart.js', { headers: { Accept: 'application/json' } })).json();
  document.querySelectorAll('.burbuja').forEach(b => { b.textContent = c.item_count; b.classList.toggle('on', c.item_count > 0); });
  const cuerpo = carrito.querySelector('[data-carrito-cuerpo]');
  const esc = t => String(t ?? '').replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]);
  const basura = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v6M14 11v6"/></svg>';
  cuerpo.innerHTML = c.item_count ? c.items.map(i => `
    <div class="carrito__item">
      <img src="${esc(i.image)}" alt="">
      <div class="carrito__info">
        <b>${esc(i.product_title)}</b>
        <b class="carrito__linea">${cop(i.final_line_price)}</b>
        ${i.variant_title ? `<span>Talla ${esc(i.variant_title)}${i.quantity > 1 ? ` · ${cop(i.final_price)} cada uno` : ''}</span>` : (i.quantity > 1 ? `<span>${cop(i.final_price)} cada uno</span>` : '')}
        <div class="carrito__acciones">
          <div class="cantidad cantidad--mini" role="group" aria-label="Cantidad de ${esc(i.product_title)}">
            <button type="button" data-cambiar="${esc(i.key)}" data-cant="${i.quantity - 1}" aria-label="Quitar uno">−</button>
            <span aria-live="polite">${i.quantity}</span>
            <button type="button" data-cambiar="${esc(i.key)}" data-cant="${i.quantity + 1}" aria-label="Agregar uno"${i.quantity >= 10 ? ' disabled' : ''}>+</button>
          </div>
          <button type="button" class="carrito__borrar" data-cambiar="${esc(i.key)}" data-cant="0" aria-label="Eliminar ${esc(i.product_title)} del carrito">${basura}</button>
        </div>
      </div>
    </div>`).join('') : '<p class="carrito__vacio">Tu carrito está vacío.</p>';
  carrito.querySelector('[data-total]').textContent = cop(c.total_price);
  return c;
}
async function agregar(boton, irAlCheckout) {
  const id = varianteElegida();
  if (!id) {
    const caja = boton.closest('[data-compra]');
    const aviso = caja?.querySelector('[data-aviso-talla]') || document.querySelector('[data-aviso-talla]');
    if (aviso) aviso.hidden = false;
    (caja?.querySelector('.talla:not([disabled])') || document.querySelector('.talla:not([disabled])'))?.focus();
    return;
  }
  const cant = document.querySelector('[data-cantidad]');
  const cantidad = cant ? Math.max(1, Math.min(5, parseInt(cant.value, 10) || 1)) : 1;
  boton.disabled = true; boton.setAttribute('aria-busy', 'true');
  try {
    const r = await fetch(RAIZ + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: cantidad }] }),
    });
    if (!r.ok) { const err = await r.json().catch(() => ({})); throw new Error(err.description || 'No pudimos agregar el buzo. Intenta de nuevo.'); }
    if (irAlCheckout) { location.href = RAIZ + 'checkout'; return; }
    await pintarCarrito(); abrirCarrito();
  } catch (err) {
    alert(err.message);
  } finally {
    boton.disabled = false; boton.removeAttribute('aria-busy');
  }
}
document.addEventListener('click', async e => {
  const comprar = e.target.closest('button[data-comprar]');
  if (comprar) { e.preventDefault(); return agregar(comprar, true); }
  const add = e.target.closest('button[data-agregar]');
  if (add) { e.preventDefault(); return agregar(add, false); }
  if (e.target.closest('[data-abrir-carrito]')) { await pintarCarrito(); abrirCarrito(); }
  if (e.target.closest('[data-cerrar-carrito]')) cerrarCarrito();
  if (e.target.closest('[data-finalizar]')) location.href = RAIZ + 'checkout';
  // subir, bajar o eliminar una línea del carrito
  const cambiar = e.target.closest('[data-cambiar]');
  if (cambiar && !cambiar.disabled) {
    carrito.querySelectorAll('[data-cambiar]').forEach(b => { b.disabled = true; });
    try {
      const r = await fetch(RAIZ + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: cambiar.dataset.cambiar, quantity: Math.max(0, Number(cambiar.dataset.cant)) }),
      });
      if (!r.ok) { const err = await r.json().catch(() => ({})); alert(err.description || 'No pudimos actualizar el carrito. Intenta de nuevo.'); }
    } finally {
      await pintarCarrito();
    }
  }
  const menu = e.target.closest('[data-menu]');
  if (menu) { const abierto = document.querySelector('.cab').classList.toggle('menu-abierto'); menu.setAttribute('aria-expanded', String(abierto)); }
});
document.addEventListener('keydown', e => { if (e.key === 'Escape') { cerrarCarrito(); document.querySelectorAll('dialog[open]').forEach(d => d.close()); } });

// cabecera con borde al bajar
const cab = document.querySelector('.cab');
if (cab) addEventListener('scroll', () => cab.classList.toggle('scrolled', scrollY > 8), { passive: true });

// apariciones
const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('en'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
document.querySelectorAll('.revela').forEach(el => io.observe(el));
